
const InThisPage = "shadow-md text-shadow  shadow-slate-800 text-center mx-auto border-2 border-orange-500 bg-orange-500 content-center max-w-xl min-w-lg px-8 rounded-lg text-sm"
const NotInThisPage ="shadow-md shadow-slate-800 text-shadow  text-center mx-auto border-2 border-orange-500 content-center bg-orange-200 max-w-xl min-w-lg px-8 rounded-lg text-sm"
const GetThisPagePath = () => {
    return(window.location.hash)
}
const Header = () => {
    return(
            <div className=" bg-orange-300 rounded-xl shadow-xl mx-2">
                <div className=' mx-2 my-2 text-shadow-md shadow-slate-800 p-2 text-xl'>
                    Meal Garage
                </div>
                    <div className="grid grid-cols-3 py-3">
                    <a href="#ScanPage" className={GetThisPagePath() === "#ScanPage"?InThisPage:NotInThisPage}>食材を取り込む</a>
                    <a href="#Refrigerator" className={GetThisPagePath() === "#Refrigerator"?InThisPage:NotInThisPage}>冷蔵庫</a>
                    <a href="#GetRecipe" className={GetThisPagePath() === "#GetRecipe"?InThisPage:NotInThisPage}>レシピを見る</a>
                </div>
            </div>
    )
}

export default Header